import { Platform } from "react-native";
import DocumentPicker from "react-native-document-picker";
import { createApiClient } from "../../../api/apiClient";
import { uploadTicketFile } from "../../../store/thunks/ticketingPortalThunk";

export interface PickedDocument {
  uri: string;
  name: string;
}

export const DOCUMENT_UPLOAD_ERROR =
  "The file could not be uploaded. Use a JPG, PNG, PDF, XLSX or DOCX file up to 10 MB.";

/** Opens the platform file picker; resolves null when the user cancels. */
export const pickDocument = (): Promise<PickedDocument | null> => {
  if (Platform.OS !== "web") {
    return DocumentPicker.pick({ allowMultiSelection: false, type: [DocumentPicker.types.allFiles] })
      .then((results) => {
        const file = results?.[0];
        return file ? { uri: file.uri, name: file.name || "attachment" } : null;
      })
      .catch((err: unknown) => {
        if (DocumentPicker.isCancel(err)) return null;
        throw err;
      });
  }

  return new Promise((resolve) => {
    const doc: any = (globalThis as any).document;
    if (!doc?.createElement) {
      resolve(null);
      return;
    }
    const input = doc.createElement("input");
    input.type = "file";
    input.accept = ".jpg,.jpeg,.png,.pdf,.xlsx,.docx";
    input.onchange = () => {
      const file = input.files?.[0];
      resolve(file ? { uri: URL.createObjectURL(file), name: file.name } : null);
    };
    input.oncancel = () => resolve(null);
    input.click();
  });
};

/** Uploads the picked file and returns the blob name the backend expects on inspections and POs. */
export const uploadPickedDocument = async (picked: PickedDocument): Promise<string> => {
  const uploaded = await uploadTicketFile(createApiClient(), picked.uri, picked.name, "ticket-document");
  if (!uploaded) throw new Error(DOCUMENT_UPLOAD_ERROR);
  return uploaded.fileName;
};
